// extracted by mini-css-extract-plugin
export default {"root":"FieldCheckbox_root__aJbdF","checkboxContainer":"FieldCheckbox_checkboxContainer__ZL-I4","checkboxLabel":"FieldCheckbox_checkboxLabel__wsNd9"};